import { cn } from '@core/utils/cn';

interface SkeletonProps {
  readonly className?: string;
}

/** Shimmer placeholder — shape it to match the content it stands in for. */
export function Skeleton({ className }: SkeletonProps): React.JSX.Element {
  return (
    <div
      className={cn('dd-skeleton rounded-md bg-line/70', className)}
      aria-hidden="true"
    />
  );
}

/** A reusable list of card-shaped skeletons for list pages. */
export function SkeletonList({ rows = 3 }: { rows?: number }): React.JSX.Element {
  return (
    <div className="flex flex-col gap-3" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-line bg-card p-5">
          <Skeleton className="h-5 w-1/2" />
          <Skeleton className="mt-3 h-3.5 w-3/4" />
          <Skeleton className="mt-2 h-3.5 w-1/3" />
        </div>
      ))}
    </div>
  );
}
